import Valuation from "./valuation/Valuation";
import ValuationsTable from "./table/ValuationsTable";
import {useState, useRef, useEffect, useLayoutEffect} from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import Login from "./login/Login";
import { ValuationDataProvider } from "./contextProviders/ValuationDataProvider";
import { GlossaryProvider } from "./contextProviders/GlossaryProvider";
import { ValuationsListProvider } from "./contextProviders/ValuationsListProvider";
import "./toolbar/toolbar.css";
import SideBar from "./sidebar/SideBar";
import verifyToken from "./methods/api/verifyToken";
import { decodeToken } from "react-jwt";
import ProtectedRoute from "./ProtectedRoute";
import UsersTable from "./table/UsersTable";
import { UsersProvider } from "./contextProviders/UsersProvider";
import MyDashboard from "./myDashboard/MyDashboard";
import FooterBar from "./footerbar/FooterBar";

function App() {
  const [authenticated, setAuthenticated] = useState(true);
  const [user, setUser] = useState({});
  const [authTimeout, setAuthTimeout] = useState(null);

  const printRef = useRef(null);
  const basicDataRef = useRef(null);
  const assumptionsRef = useRef(null);
  const assumptionsAdvancedRef = useRef(null);
  const analyticsRef = useRef(null);
  const financialRef = useRef(null);
  const calculationsRef = useRef(null);
  const valuationBasisRef = useRef(null);

  const navigate = useNavigate();

    useLayoutEffect(() => {
    verifyToken().then((status) => {
      if (status == 200) {
        setAuthenticated(true);
        let decodedToken = decodeToken(window.localStorage.token);
        if (!decodedToken || !decodedToken.exp) {
          console.error("Invalid JWT format or missing expiration time");
        } else {
          const expirationTime = decodedToken.exp * 1000;
          const currentTime = new Date().getTime();
          const timeRemaining = expirationTime - currentTime;
          setAuthTimeout(
            setTimeout(() => {
              navigate("/login");
            }, timeRemaining)
          );
          setUser({
            username: decodedToken.username,
            role: decodedToken.role,
            token: window.localStorage.token,
          });
          return () => clearTimeout(authTimeout);
        }
      } else {
        setAuthenticated(false);
        window.localStorage.removeItem("token");
      }
    });
  }, []);

  return (
    <div className="App">
      <ValuationsListProvider>
        {/*<ValuationDataProvider>*/}
          <SideBar
            refs={{
              printRef,
              basicDataRef,
              assumptionsRef,
              assumptionsAdvancedRef,
              analyticsRef,
              financialRef,
              calculationsRef,
                valuationBasisRef
            }}
            authenticated={authenticated}
            user={user}
          />
          <Routes>
            <Route
              path="/login"
              element={
                <Login
                  setAuthenticated={setAuthenticated}
                  setUser={setUser}
                  authTimeout={authTimeout}
                  setAuthTimeout={setAuthTimeout}
                />
              }
            />
            <Route
              path="/uzytkownicy"
              element={
                <ProtectedRoute
                  authenticated={authenticated}
                  user={user}
                  adminOnly={true}
                >
                  <UsersProvider>
                    <UsersTable />
                  </UsersProvider>
                </ProtectedRoute>
              }
            />
            <Route
              path="/moje_dane"
              element={
                <ProtectedRoute
                  authenticated={authenticated}
                  user={user}
                >
                  <MyDashboard user={user} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/wyceny"
              element={
                <ProtectedRoute authenticated={authenticated} user={user}>
                  <ValuationsTable user={user} authenticated={authenticated} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/wyceny/*"
              element={
                <ProtectedRoute authenticated={authenticated} user={user}>
                  <GlossaryProvider>
                    <Valuation
                      authenticated={authenticated}
                      refs={{
                        printRef,
                        basicDataRef,
                        assumptionsRef,
                        assumptionsAdvancedRef,
                        analyticsRef,
                        financialRef,
                        calculationsRef,
                          valuationBasisRef
                      }}
                    />
                  </GlossaryProvider>
                </ProtectedRoute>
              }
            />
          </Routes>
            <FooterBar/>
        {/*</ValuationDataProvider>*/}
      </ValuationsListProvider>
    </div>
  );
}

export default App;
